const ranges = [
    {divider: 1e18, suffix: 'E'},
    {divider: 1e15, suffix: 'P'},
    {divider: 1e12, suffix: 'T'},
    {divider: 1e9, suffix: 'G'},
    {divider: 1e6, suffix: 'M'},
    {divider: 1e3, suffix: 'K'},
];

export function GeneralService() {
    return {
        prettyTotalStaked(amount: string) {
            let num = parseFloat(amount);
            let numStr = num.toString().slice(0, 12);
            numStr = Number(numStr).toFixed(2);
            const prettyTotal = this.formatNumber(Number(numStr));
            return prettyTotal;
        },

        formatNumber(n: number) {
            for (let i = 0; i < ranges.length; i++) {
                if (n >= ranges[i].divider) {
                    return (n / ranges[i].divider).toString() + ranges[i].suffix;
                }
            }
            return n.toString();
        },
        async getAMASAPrice() {
            const requestOptions = {
                method: 'GET',
            };
            try {
                const queryParams = 'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=amasa';
                const response = await fetch(queryParams, requestOptions);
                const [result] = JSON.parse(await response.text());
                return result['current_price'];
            } catch (error) {
                return '-1';
            }
        },
    };
}
